import React from 'react';
import cn from 'classnames';

import Button from '../../../common/ui/Button';
import Modal from '../../../common/ui/Modal';
import SupportIcon from '../../../../assets/icons/common/SupportIcon';
import DisappointedSmileIcon from '../../../../assets/icons/common/DisappointedSmileIcon';
import { openGladlyChat } from '../../../../utils/gladly';

import styles from './styles.module.scss';

const BeforeYouGoModal = ({
  isOpen,
  onClose,
  isBtnDisabled,
  isBtnLoading,
  onSubmit,
  description = 'We can help fix your device issue, often quickly',
}) => {
  return (
    <Modal
      preventClosing={true}
      isOpen={isOpen}
      onClose={onClose}
      className={styles.beforeYouGoModal}
    >
      <h3 className={cn('h3', styles.title)}>Before You Go</h3>
      <p>{description}</p>
      <div className={styles.controllWrapper}>
        <Button className={styles.supportButton} onClick={openGladlyChat}>
          <SupportIcon /> Contact Support
        </Button>
        <Button
          className={styles.cancelButton}
          colorType={'white'}
          onClick={onSubmit}
          disabled={isBtnDisabled}
          isLoading={isBtnLoading}
        >
          <DisappointedSmileIcon />
          Proceed with Cancellation
        </Button>
      </div>
    </Modal>
  );
};
export default BeforeYouGoModal;
